/** @format */

import names from './names.json';

type sensorNames = {
  [key: string]: string | undefined;
};

export const sensorName = (techName: string): string => {
  return (names as sensorNames)[techName] || '';
};
